import QRCode from 'qrcode';
import { signIn } from './auth.js';
import { esc } from './ui.js';

const shell = (inner) => `<main class="login"><div class="box">
  <div class="brand"><img class="logo" src="/assets/logo-full.svg" alt="Magnolia &amp; Oak" width="1100" height="685"></div>
  <p class="eyebrow" style="text-align:center">Staff portal</p>
  ${inner}</div></main>`;

// Renders one step and resolves with the submitted value.
function prompt(root, html, field) {
  return new Promise((resolve) => {
    root.innerHTML = shell(html);
    const form = root.querySelector('form');
    form.querySelector('input')?.focus();
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = new FormData(form);
      if (field === 'newPassword') {
        if (v.get('pw') !== v.get('pw2')) { form.querySelector('[data-error]').innerHTML = '<p class="notice error">Passwords don\'t match.</p>'; return; }
        resolve(v.get('pw'));
      } else {
        resolve(String(v.get('code') || '').replace(/\s/g, ''));
      }
      root.innerHTML = shell('<p class="muted">Checking…</p>');
    });
  });
}

const codeField = `<label class="field"><span>6-digit code</span><input name="code" inputmode="numeric" autocomplete="one-time-code" pattern="[0-9 ]*" required></label>`;

export function renderLogin(root, onDone, message = '') {
  root.innerHTML = shell(`
    <h1 style="font-size:28px">Sign in</h1>
    ${message ? `<p class="notice">${esc(message)}</p>` : ''}
    <form id="signin" style="display:flex;flex-direction:column;gap:16px" novalidate>
      <label class="field"><span>Email</span><input name="email" type="email" autocomplete="username" required></label>
      <label class="field"><span>Password</span><input name="password" type="password" autocomplete="current-password" required></label>
      <div data-error></div>
      <button class="btn primary" type="submit">Sign in</button>
    </form>
    <p class="small muted">Accounts are created by an owner. Forgot your password? Ask an owner to reset it.</p>`);
  const form = root.querySelector('#signin');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const f = new FormData(form);
    const email = String(f.get('email') || '');
    const password = String(f.get('password') || '');
    if (!email || !password) { form.querySelector('[data-error]').innerHTML = '<p class="notice error">Enter your email and password.</p>'; return; }
    form.querySelector('button').disabled = true;
    try {
      await signIn(email, password, async (step, data) => {
        if (step === 'newPassword') {
          return prompt(root, `<h1 style="font-size:26px">Choose a new password</h1>
            <p class="small muted">At least 12 characters with upper and lower case letters, a number, and a symbol.</p>
            <form style="display:flex;flex-direction:column;gap:16px">
              <label class="field"><span>New password</span><input name="pw" type="password" autocomplete="new-password" required minlength="12"></label>
              <label class="field"><span>Confirm password</span><input name="pw2" type="password" autocomplete="new-password" required></label>
              <div data-error></div><button class="btn primary" type="submit">Continue</button></form>`, 'newPassword');
        }
        if (step === 'setupTotp') {
          const uri = `otpauth://totp/${encodeURIComponent(`Magnolia & Oak:${data.email}`)}?secret=${data.secret}&issuer=${encodeURIComponent('Magnolia & Oak')}`;
          const qr = await QRCode.toDataURL(uri, { margin: 1, width: 220 });
          return prompt(root, `<h1 style="font-size:26px">Set up two-step sign-in</h1>
            <p class="small muted">Scan this with an authenticator app (Google Authenticator, 1Password, Authy), then enter the 6-digit code it shows.</p>
            <img class="qr" src="${qr}" alt="QR code for your authenticator app">
            <p class="small muted">Can't scan? Enter this key in the app:</p><code class="secret">${esc(data.secret)}</code>
            <form style="display:flex;flex-direction:column;gap:16px">${codeField}<button class="btn primary" type="submit">Verify</button></form>`, 'code');
        }
        return prompt(root, `<h1 style="font-size:26px">Enter your code</h1>
          <p class="small muted">Open your authenticator app and enter the current code for Magnolia &amp; Oak.</p>
          <form style="display:flex;flex-direction:column;gap:16px">${codeField}<button class="btn primary" type="submit">Verify</button></form>`, 'code');
      });
      onDone();
    } catch (err) {
      renderLogin(root, onDone, err.message);
    }
  });
}
